// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4759":"4859b392","8611":"0a7325da"}[chunkId] + ".chunk.css";
};